import React, { useEffect, useState } from "react";
import { getHistoryPage } from "../contentful";
import marked from "marked";
import { Row, Col } from "react-bootstrap";
import Titlebar from "./TitleBar";
import lucille from "../assets/imgs/lucille-graham.jpg";
import norman from "../assets/imgs/norman-mccann.jpg";
import { Helmet } from "react-helmet";

const History = () => {
  const [text, setText] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getHistoryPage().then((data) => setText(data));
  }, []);

  return (
    <div>
      <Helmet>
        <title>History of the Lucille Graham Trust</title>
        <meta
          name="description"
          content="The Lucille Graham Trust was established in 1992 by concert agent Professor Norman McCann FRAM, in memory of his late wife Lucille Graham."
        />
        <link
          rel="canonical"
          href="https://www.lucillegrahamtrust.org.uk/history"
        />
      </Helmet>
      <Titlebar title="History" />

      <div className="content">
        {text.map((content) => {
          const para1 = marked(content.fields.content);
          const para2 = marked(content.fields.content2);
          return (
            <div>
              <Row>
                <Col md={10}>
                  <div
                    className="history-text"
                    dangerouslySetInnerHTML={{ __html: para1 }}
                  />
                </Col>
                <Col md={2}>
                  <img src={lucille} style={{ width: "100%" }} alt="Lucille Graham photographed by Russell Sedgwick." />
                  <small>
                    Lucille Graham
                    <br />
                    photographed by Russell Sedgwick.
                  </small>
                </Col>
              </Row>
              <Row style={{ marginTop: 45 }}>
                <Col md={2}>
                  <img src={norman} alt="Norman McCann" style={{ width: "100%" }} />
                  <small>
                    Norman McCann, stage name Paul Manning, early in his career
                    <br />
                    unknown photographer.
                  </small>
                </Col>
                <Col md={10}>
                  <div
                    className="history-text"
                    dangerouslySetInnerHTML={{ __html: para2 }}
                  />
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default History;
